import ContentHeader from "../../../layout/ContenteHeader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileInvoiceDollar, faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import { Dropdown } from "react-bootstrap";

const currentYear = new Date().getFullYear();
const yearOptions = Array.from({ length: 6 }, (_, i) => currentYear - i);

const FinanceHeader = ({ direction, year, setYear }) => {
  const incoming = direction === "in";
  const gradient = incoming
    ? "linear-gradient(135deg, #c62828 0%, #8e0000 100%)"
    : "linear-gradient(135deg, #2e7d32 0%, #1b5e20 100%)";
  const shadow = incoming
    ? "0 4px 12px rgba(198,40,40,0.3)"
    : "0 4px 12px rgba(46,125,50,0.3)";

  return (
    <ContentHeader>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
          <div style={{
            width: "46px",
            height: "46px",
            borderRadius: "12px",
            background: gradient,
            color: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "1.2rem",
            flexShrink: 0,
            boxShadow: shadow,
          }}>
            <FontAwesomeIcon icon={faFileInvoiceDollar} />
          </div>
          <div>
            <div style={{ fontSize: "1.5rem", fontWeight: 800, color: "#212121", lineHeight: 1.2 }}>
              Finance
            </div>
            <div style={{ fontSize: "0.85rem", color: "#9e9e9e", marginTop: "2px" }}>
              Manage your bills, offers and orders
            </div>
          </div>
        </div>
        {year !== undefined && setYear && (
          <Dropdown onClick={(e) => e.stopPropagation()}>
            <Dropdown.Toggle
              as="button"
              bsPrefix="no-caret"
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "6px",
                padding: "8px 14px",
                background: "#e8f0fe",
                border: "none",
                borderRadius: "8px",
                fontWeight: 600,
                fontSize: "0.92rem",
                color: "#1a73e8",
                cursor: "pointer",
              }}
            >
              <FontAwesomeIcon icon={faCalendarAlt} style={{ fontSize: "0.85rem" }} />
              {year}
            </Dropdown.Toggle>
            <Dropdown.Menu style={{
              borderRadius: "10px",
              boxShadow: "0 4px 20px rgba(0,0,0,0.12)",
              border: "1px solid #f0f0f0",
              padding: "6px",
              minWidth: "120px",
              marginTop: "4px",
            }}>
              {yearOptions.map((y) => (
                <Dropdown.Item
                  key={y}
                  as="div"
                  onClick={() => setYear(y)}
                  style={{
                    borderRadius: "7px",
                    fontSize: "0.92rem",
                    fontWeight: y === year ? 700 : 500,
                    color: y === year ? "#1a73e8" : "#424242",
                    background: y === year ? "#e8f0fe" : "transparent",
                    padding: "8px 14px",
                    cursor: "pointer",
                  }}
                >
                  {y}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        )}
      </div>
    </ContentHeader>
  );
};

export default FinanceHeader;
